<template>
    <div>
        <div class="white-box white-box-no-tab text-base xs:text-lg pb-10">
            <Title
                styleCodePage
                :text="$route.meta.pageTitle"
            />

            <h4 class="py-3 md:pb-3.5 md:pt-0">
                請選擇您欲延長有效期限的信用卡
            </h4>
            <div class="pb-3.5">
                <!-- <transition
                    name="opacity"
                    mode="out-in"
                > -->
                <Skeletons v-if="!radioList && !disabledList" />
                <Nodata v-else-if="radioList.length === 0">
                    無保單資料
                </Nodata>
                <div v-else>
                    <div class="lg:hidden pad:grid pad:grid-cols-2 pad:gap-4 lg:hidden">
                        <PolicyCard
                            v-for="(data, index) in radioList"
                            :key="index"
                            v-model:checkedRadio="cardNo"
                            :row="data"
                            :disabled="false"
                        />
                    </div>

                    <!-- for computer -->
                    <PolicyTable
                        v-model:checkedRadio="cardNo"
                        :data="radioList"
                        class="hidden lg:block"
                    />
                </div>
                <!-- </transition> -->
                <template v-if="disabledList &&disabledList.length > 0">
                    <h5 class="pb-3 pt-8">
                        無法辦理之保單
                    </h5>
                    <div>
                        <div class="lg:hidden pad:grid pad:grid-cols-2 pad:gap-4 lg:hidden">
                            <PolicyCard
                                v-for="(data, index) in disabledList"
                                :key="index"
                                v-model:checkedRadio="cardNo"
                                :row="data"
                                :disabled="true"
                            />
                        </div>

                        <!-- for computer -->
                        <PolicyTable
                            :data="disabledList"
                            :disabled="true"
                            class="hidden lg:block"
                        />
                    </div>
                </template>
            </div>
        </div>

        <Bottombar :control-visible="!!cardNo">
            <template #right>
                <button
                    class="btn btn-accent rounded-full"
                    :disabled="!cardNo"
                    @click="goNext()"
                >
                    下一步
                </button>
            </template>
        </Bottombar>
        <Loading :isLoading="isLoading" />
    </div>
</template>

<script>
import { ref, toRefs, reactive, computed, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Title from '@/components/text/Title.vue';
import Bottombar from '@/components/layout/Bottombar.vue';
import Loading from '@/components/Loading.vue';
import Nodata from '@/components/text/EmptyData.vue';
import routeName from '@/router/constant.js';
import PolicyCard from './PolicyCard.vue';
import PolicyTable from './PolicyTable.vue';
import Skeletons from '@/components/skeletons/SkeletonsCardTable.vue';
import { getInfoCreditCardExp } from '@/apis/aplCatlCreditCardExp';
import codeList from '@/json/codeList.js';
import dialogContent from '@/json/dialogContent';
import { formatCreditCardNo } from '@/utils/number/formatCreditCardNo';

export default {
    components: {
        Title,
        PolicyCard,
        Bottombar,
        Loading,
        Nodata,
        PolicyTable,
        Skeletons
    },
    setup() {
        const $vfm = inject('$vfm');
        const store = useStore();
        const router = useRouter();
        const isDisableButton = ref(false);
        const code = codeList.CREDIT_CARD_EXP;
        const isLoading = ref(false);
        const radioList = ref(null);
        const disabledList = ref(null);
        const resultUserInfo = computed(() => store.state.services.changeItemsResult[code]);

        const info = reactive({
            cardBankName: '',
            cardBank: '',
            cardNo: '',
            month: '',
            year: '',
            label: ''
        });
        // 產生卡號&'-'字串
        const formatCreditCard = (ary) => {
            return ary.map(i => {
                i.label = formatCreditCardNo(i.cardNo);
                return i;
            });
        };

        // 取得資料
        (() => {
            getInfoCreditCardExp().then(res => {
                radioList.value = formatCreditCard(res.data.creditCardExpList);
                disabledList.value = formatCreditCard(res.data.notCreditCardExpList);
                if (resultUserInfo.value) {
                    const { cardNo, month, year } = resultUserInfo.value;
                    info.cardNo = cardNo;
                    info.month = month;
                    info.year = year;
                }
            });
        })();
        const modalShow = (params, on) => {
            $vfm.show({
                component: 'DialogBase',
                params,
                on
            });
        };
        const goNext = () => {
            isLoading.value = true;
            const obj = radioList.value.find(i => i.cardNo === info.cardNo);
            if (obj) {
                info.cardBank = obj.cardBank;
                info.cardBankName = obj.cardBankName;
                info.label = obj.label;
                store.dispatch('services/setChangeItemsResult', { code, value: info });
                router.push({ name: routeName.CREDITCARD_EXPIRY_DATE });
            } else {
                modalShow(dialogContent.refresh, {
                    confirm() {
                        $vfm.hide('DialogBase');
                        router.go(0);
                    },
                });
            }
        };
        return {
            isDisableButton,
            isLoading,
            radioList,
            disabledList,
            goNext,
            ...toRefs(info),
        };
    },
};
</script>
<style lang="scss" scoped>
.expand-leave-active,
.expand-enter-active {
    transition: max-height 0.2s linear;
}
.expand-enter-from,
.expand-leave-to {
    max-height: 0;
    overflow: hidden;
}

.expand-enter-to,
.expand-leave-from {
    max-height: 200px;
    overflow: hidden;
}
</style>
